import getCollection from '../../../utils/db/getCollection'
import getDoc from '../../../utils/db/getDoc'
import promiseAllValues from '../../../utils/promiseAllValues'
import buildOutletCatalogGlobalCategories from './buildOutletCatalogGlobalCategories'
import buildOutletCategoryBranch from './buildOutletCategoryBranch'
import filterOutletCatalogProducts from './filterOutletCatalogProducts'
import { OUTLET_SHOP_ID } from './outletCategoryConstants'

export const loadOutletCategoryBranch = ({ brandIds = [] } = {}) =>
  promiseAllValues({
    outletProducts: getCollection({ path: 'outletProducts', docIdName: 'id' }),
    globalCategories: getCollection({ path: 'globalCategories', docIdName: 'id' }),
    categories: getCollection({ path: 'categories', docIdName: 'id' }),
    brands: getCollection({ path: 'brands', docIdName: 'id' }),
    outletShop: getDoc({ path: 'shops', docId: OUTLET_SHOP_ID, docIdName: 'id' }),
  }).then(({ outletProducts, globalCategories, categories, brands, outletShop }) => {
    const filteredProducts = filterOutletCatalogProducts({
      products: outletProducts,
      brands,
      categories,
      remains: outletShop,
      brandIds,
    })

    const outletGlobalCategories = buildOutletCatalogGlobalCategories(
      globalCategories,
      filteredProducts,
      categories
    )

    return buildOutletCategoryBranch(outletGlobalCategories, filteredProducts)
  })

export default loadOutletCategoryBranch
